(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-text"] && !Shopify.designMode) return;
  try {
    

 var TxtType = function(el, toRotate, period) {
        this.toRotate = toRotate;
        this.el = el;
        this.loopNum = 0;
        this.period = parseInt(period, 10) || 2000;
        this.txt = '';
        this.tick();
        this.isDeleting = false;
    };

    TxtType.prototype.tick = function() {
        var i = this.loopNum % this.toRotate.length;
        var fullTxt = this.toRotate[i];

        if (this.isDeleting) {
        this.txt = fullTxt.substring(0, this.txt.length - 1);
        } else {
        this.txt = fullTxt.substring(0, this.txt.length + 1);
        }

        this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>';

        var that = this;
        var delta = 200 - Math.random() * 100;

        if (this.isDeleting) { delta /= 2; }

        if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
        } else if (this.isDeleting && this.txt === '') {
        this.isDeleting = false;
        this.loopNum++;
        delta = 500;
        }

        setTimeout(function() {
        that.tick();
        }, delta);
    };

    window.onload = function() {
        var elements = document.getElementsByClassName('typewrite');
        for (var i = 0; i < elements.length; i++) {
            var toRotate = elements[i].getAttribute('data-type');
            var period = elements[i].getAttribute('data-period');
            if (toRotate) {
                new TxtType(elements[i], JSON.parse(toRotate), period);
            }
            var borderColor = elements[i].getAttribute('data-cursor-color') || "#fff";
            var parent = elements[i].closest('section[id^="dynamic-"]');
            var styleId = 'typewrite-cursor-style-' + i;
            var css = document.createElement("style");
            css.id = styleId;
            var scope = parent ? ('#' + parent.id + ' ') : '';
            css.innerHTML = scope + ".typewrite > .wrap { border-right: 0.08em solid " + borderColor + "; }";
            document.head.appendChild(css);
        }
    };


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumis-editorial-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-lumis-hero]').forEach((hero) => {
      if (hero.dataset.lumisHeroReady === 'true') return;
      hero.dataset.lumisHeroReady = 'true';

      const slides = Array.from(hero.querySelectorAll('[data-lumis-slide]'));
      const dots = Array.from(hero.querySelectorAll('[data-lumis-hero-dot]'));
      const toggle = hero.querySelector('[data-lumis-hero-toggle]');
      if (slides.length < 2 || !toggle) return;

      let current = 0;
      let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let timer;

      const update = (nextIndex) => {
        current = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const active = index === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach((dot, index) => {
          const active = index === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const schedule = () => {
        window.clearTimeout(timer);
        if (!paused) {
          timer = window.setTimeout(() => {
            update(current + 1);
            schedule();
          }, Number(hero.dataset.interval) || 7000);
        }
      };

      const updateToggle = () => {
        toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        toggle.textContent = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
      };

      toggle.addEventListener('click', () => {
        paused = !paused;
        updateToggle();
        schedule();
      });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          update(index);
          schedule();
        });
      });

      update(0);
      updateToggle();
      schedule();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumis-product-story-media"] && !Shopify.designMode) return;
  try {
    
  const pauseStoryVideosForReducedMotion = (root = document) => {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    root.querySelectorAll('.lumis-product-story__video').forEach((video) => {
      video.removeAttribute('autoplay');
      video.pause();
      video.currentTime = 0;
    });
  };

  pauseStoryVideosForReducedMotion();

  const initProductStoryCarousels = (root = document) => {
    root.querySelectorAll('[data-product-story-carousel]').forEach((carousel) => {
      const images = Array.from(carousel.querySelectorAll('img'));
      if (images.length < 2) {
        images[0]?.classList.add('is-active');
        return;
      }

      let activeIndex = 0;
      images[activeIndex].classList.add('is-active');
      const interval = Math.max(Number(carousel.dataset.interval) || 5000, 3500);
      window.setInterval(() => {
        images[activeIndex].classList.remove('is-active');
        activeIndex = (activeIndex + 1) % images.length;
        images[activeIndex].classList.add('is-active');
      }, interval);
    });
  };

  initProductStoryCarousels();
  document.addEventListener('shopify:section:load', (event) => {
    pauseStoryVideosForReducedMotion(event.target);
    initProductStoryCarousels(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
